<template>
    <b-card
            header="Claimant Provider Assignments"
            header-text-variant="white"
            header-bg-variant="info"
    >
        <b-row>
            <b-col sm="6">
                <b-row>
                    <b-col sm="6" md="4" class="my-1">

                        <user-role-search-dropdown type="provider" v-model=" filterCaregiverId "></user-role-search-dropdown>
                    </b-col>
                    <b-col sm="6" md="4" class="my-1">

                        <user-role-search-dropdown type="claimant" v-model=" filterClientId "></user-role-search-dropdown>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-table bordered striped hover show-empty
                 :fields="fields"
                 :items="filteredItems"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc"
                 class="shift-table"
        >
            <template v-slot:cell(provider_rate)="data">{{ numberFormat(data.value) }}</template>
            <template v-slot:cell(actions)="row">
                <b-btn :href="'/business/clients/' + row.item.policy_holder_id + '#caregivers'">View Claimant Tab</b-btn>
            </template>
        </b-table>
    </b-card>
</template>

<script>
    import FormatsNumbers from '../mixins/FormatsNumbers';

    export default {
        mixins: [FormatsNumbers],

        props: {},

        data() {

            return {

                items: [],
                sortBy: null,
                sortDesc: null,
                filterCaregiverId: "",
                filterClientId: "",
            }
        },

        mounted() {
            this.loadData();
        },

        computed: {
            fields() {
                let fields = [];
                let item;
                if (item = this.items[0]) {
                    for (let key of Object.keys(item)) {
                        if (key === 'policy_holder_id') continue;
                        if (key === 'provider_id') continue;
                        fields.push({
                            'key': key,
                            'sortable': true,
                        });
                    }

                }
                fields.push({
                    key: 'actions',
                    class: 'hidden-print'
                });
                return fields;
            },
            filteredItems() {
                let items = this.items;
                if (this.filterCaregiverId || this.filterClientId) {
                    items = items.filter(item => {
                        if (this.filterCaregiverId && this.filterCaregiverId != item.provider_id) return false;
                        if (this.filterClientId && this.filterClientId != item.policy_holder_id) return false;
                        return true;
                    });
                }
                return items;
            }
        },

        methods: {
            loadData() {
                let component = this;
                axios.get('/business/reports/client_caregivers?json=1')
                    .then(function(response) {
                        if (Array.isArray(response.data)) {
                            component.items = response.data;
                        }
                        else {
                            component.items = [];
                        }
                    });
            }
        },
    }
</script>

<style>
    table {
        font-size: 14px;
    }
</style>